export default "__VITE_ASSET__b13f0f3e__"